import { useTranslation } from 'react-i18next'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const useAreaValidationSchema = () => {
	const { t } = useTranslation()

	const boothValidationSchema = yup.object({
		number: yup
			.string()
			.matches(/^\d+$/, t('The field should have digits only'))
			.required(t('This field is required')),
		boothType: yup.object({
			value: yup.string().required(t('This is required'))
		})
	})

	return yupResolver(boothValidationSchema)
}
